import { connect } from "react-redux";
import { Box } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect, useMemo } from "react";
import { selectTags } from "../../redux/selectors/firebase";
import { Tags } from "../graph/StateTags";
import InteractiveScript from "./InteractiveScript";
import PagedScript from "./PagedScript";
import { logEvent, getAnalytics } from "firebase/analytics";
import { selectFocus, selectModeData } from "../../redux/selectors/editor";
import { ActionFactory } from "../../fstn/actionFactory";
import { Network } from "../../fstn/network";
import { IScriptData } from "../../redux/slices/editor";

const useScriptStyles = makeStyles(theme => ({
    screen: {
        width: "min-content",
        margin: "auto",
        position: 'absolute',
        display: 'flex',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
    },
    printScreen: {
        display: "flex",
        width: "min-content",
        height: "100%",
        margin: "auto",
    }
}));

interface Props
{
    modeData: IScriptData
    focus: string
    factory: ActionFactory
    network: Network
    tags: Tags
}
function Script({ modeData, focus, factory, network, tags }: Props)
{
    const classes = useScriptStyles(network);

    useEffect(() =>
    {
        logEvent(getAnalytics(), "page_view", {
            page_location: "/script"
        });
    }, []);

    useEffect(() =>
    {
        if (focus)
        {
            document.getElementById(focus)?.scrollIntoView();
        }
    }, [focus]);

    const scriptModes = useMemo(() => ({
        default: PagedScript,
        interactive: InteractiveScript
    }), []);

    const script = useMemo(() => React.createElement(scriptModes[modeData.scriptMode as keyof typeof scriptModes] ?? scriptModes.default, { network, factory }),
        [factory, network, modeData.scriptMode, scriptModes]);

    return (
        <Box>
            <Box className={classes.screen}>
                {script}
            </Box>
        </Box>
    );
}const mapStateToProps = (store: never) => ({
    focus: selectFocus(store),
    tags: selectTags(store) ?? {},
    modeData: selectModeData(store)
});

export default connect(mapStateToProps, {
})(Script);

